import { Link as RouterLink } from 'react-router-dom';
import { Button, Tab, Tabs, Typography, styled } from '@material-ui/core';
import { ParagraphText } from '../Markdown/ParagraphText';

const FONT = { display: 'Red Hat Display', body: 'Open Sans' } as const;
const FONT_SIZE = { body: 14, bodyLarge: 16 } as const;

export { ParagraphText };

export const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  padding: 24,
  marginBottom: 24,
});

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontFamily: FONT.display,
  fontWeight: 700,
  fontSize: 34,
  color: theme.palette.text.primary,
  marginBottom: 20,
}));

export const TabsWrapper = styled('div')({
  marginBottom: 24,
});

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: 44,
  '& .MuiTabs-indicator': {
    height: 2,
    backgroundColor: theme.palette.primary.main,
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  minWidth: 0,
  padding: '10px 30px',
  fontFamily: FONT.display,
  fontSize: FONT_SIZE.body,
  fontWeight: 700,
  lineHeight: '16px',
  letterSpacing: 0.5,
  textTransform: 'uppercase',
  ['&:not(&.Mui-selected)']: {
    color: theme.palette.text.secondary,
  },
}));

export const DocsContent = styled('div')({
  minWidth: 0,
});

export const DocContentLink = styled(RouterLink)(({ theme }) => ({
  fontFamily: FONT.body,
  fontWeight: 400,
  fontStyle: 'normal',
  fontSize: FONT_SIZE.bodyLarge,
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const ArticleContentWrapper = styled('div')({
  maxWidth: 1200,
});

export const BackButton = styled(Button)({
  fontWeight: 700,
  marginBottom: 16,
});
